import { ComponentStyleConfig } from "@chakra-ui/react";

export const icon: ComponentStyleConfig = {
  baseStyle: {
    boxSize: "kilo",
  },
};
